import React from "react";
import { useHistory } from "react-router-dom";

const PendingTripCard = ({ dashboard }) => {
  const history = useHistory();
  return (
    <div className="pending-card">
      <h2 className="flex-between">
        <span>Pending Trips</span>
        <span
          className="active-text cursor"
          onClick={() => {
            history.push("/trips", {
              filter: "pending_approval"
            });
          }}
        >
          View all
        </span>
      </h2>
      <div className="mb1">
        <div className="titles">
          <span>User</span>
          <span>Trip Name</span>
        </div>
      </div>
      {dashboard?.pending_trip?.length > 0 ? (
        dashboard?.pending_trip?.map((ele) => (
          <div className="values">
            <aside
              className="cursor"
              onClick={() => {
                history.push(`/trip-details/${ele.trip_id}`);
              }}
            >
              {/* <b> 14 May 2022</b> <br /> */}
              <span
                style={{
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <span className="circle">{ele.user_name?.[0]}</span>
                {ele.user_name}
              </span>
            </aside>
            <aside>{ele.title}</aside>
          </div>
        ))
      ) : (
        <div className="no-data">
          <span>No Pending trips</span>
        </div>
      )}
    </div>
  );
};

export default PendingTripCard;
